import { render, staticRenderFns } from "./CompareHorizontal.vue?vue&type=template&id=02f72e74&scoped=true&"
import script from "./CompareHorizontal.vue?vue&type=script&lang=js&"
export * from "./CompareHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./CompareHorizontal.vue?vue&type=style&index=0&id=02f72e74&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f72e74",
  null
  
)

export default component.exports